export default "/images/chevron-down.svg?789347650663abf16e25a4d5ed831e14";